<template>
  <div>
    <div class="webrtc-camera">
      <div class="camera-control">
        <button class="control-button" @click="startCamera">Bật Camera</button>
        <button class="control-button" @click="stopCamera">Tắt Camera</button>
        <button class="control-button" @click="takePhoto" v-if="isTakePhoto">Chụp Ảnh</button>
        <button class="control-button" @click="reTakePhoto" v-else>Chụp Lại</button>
        <svg class="progress-circle" viewBox="0 0 100 100" @click="toggleRecording">
          <circle
            class="progress-circle__background"
            cx="50"
            cy="50"
            r="45"
            fill="transparent"
            stroke="#e6e6e6"
            stroke-width="10"
          />
          <rect x="35" y="35" width="30" height="30" fill="red" v-if="isRecording" />
          <text
            x="50"
            y="55"
            text-anchor="middle"
            fill="black"
            font-size="16"
            font-family="Arial"
            v-else
          >
            Ghi Hình
          </text>
          <circle
            class="progress-circle__value"
            cx="50"
            cy="50"
            r="45"
            fill="transparent"
            stroke="#F44336"
            stroke-width="10"
            :style="{
              strokeDasharray: circumference,
              strokeDashoffset: strokeDashoffset,
            }"
            v-if="isRecording"
          />
        </svg>
      </div>
      <video ref="videoElement" width="400" height="300" autoplay v-show="isDisplayVideo"></video>
      <canvas ref="photoCanvas" width="400" height="300" v-show="isDisplayImg"></canvas>
      <video
        ref="recordingVideo"
        controls
        v-show="isDisplayVideoRecorded"
        width="400"
        height="300"
      ></video>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'WebRTCCamera',
    data() {
      return {
        mediaStream: null,
        mediaRecorder: null,
        recordedChunks: [],
        isRecording: false,
        recordingDuration: 30, // 1 phút
        recordedDuration: 0,
        timerInterval: null,
        isTakePhoto: true,
        isDisplayImg: false,
        isDisplayVideo: true,
        isDisplayVideoRecorded: false,

        circumference: 2 * Math.PI * 45, // Chu vi hình tròn
        progress: 0, // Tiến độ hiện tại
        strokeDashoffset: 2 * Math.PI * 45, // Độ dồn đường viền ban đầu
        animationId: null, // ID của hiệu ứng hoạt ảnh
      }
    },
    mounted() {
      this.startCamera()
    },
    watch: {},
    computed: {},
    methods: {
      startCamera() {
        this.isDisplayVideo = true
        navigator.mediaDevices
          .getUserMedia({ video: true, audio: false })
          .then(stream => {
            this.mediaStream = stream
            this.$refs.videoElement.srcObject = stream
            this.$refs.videoElement.play()
          })
          .catch(error => {
            console.log('Không thể truy cập camera:', error)
          })
      },
      stopCamera() {
        if (this.mediaStream) {
          const tracks = this.mediaStream.getTracks()
          tracks.forEach(track => {
            track.stop()
          })
          this.mediaStream = null
          this.$refs.videoElement.srcObject = null
          this.isDisplayVideo = false
        }
      },
      takePhoto() {
        if (this.mediaStream) {
          this.isDisplayImg = true
          this.isTakePhoto = false
          const canvas = this.$refs.photoCanvas
          const context = canvas.getContext('2d')
          context.drawImage(this.$refs.videoElement, 0, 0, canvas.width, canvas.height)
          this.stopCamera()
        }
      },
      reTakePhoto() {
        this.isTakePhoto = true
        this.isDisplayImg = false
        this.startCamera()
      },
      toggleRecording() {
        if (!this.isRecording) {
          this.startRecording()
        } else {
          this.stopRecording()
        }
      },
      startRecording() {
        if (this.mediaStream) {
          this.startAnimation()
          this.recordedChunks = []
          this.mediaRecorder = new MediaRecorder(this.mediaStream)
          this.mediaRecorder.ondataavailable = event => {
            if (event.data.size > 0) {
              this.recordedChunks.push(event.data)
            }
          }
          this.mediaRecorder.onstop = this.saveRecording
          this.mediaRecorder.start()
          this.isRecording = true
          this.timerInterval = setInterval(this.updateRecordedDuration, 1000)
        }
      },
      stopRecording() {
        if (this.mediaRecorder && this.isRecording) {
          this.isDisplayVideoRecorded = true
          this.mediaRecorder.stop()
          clearInterval(this.timerInterval)
          this.isRecording = false
          this.recordedDuration = 0
          this.stopAnimation()
          this.stopCamera()
        }
      },
      updateRecordedDuration() {
        this.recordedDuration += 1
        if (this.recordedDuration >= this.recordingDuration) {
          this.stopRecording()
        }
      },
      saveRecording() {
        const blob = new Blob(this.recordedChunks, { type: 'video/webm' })
        const url = URL.createObjectURL(blob)
        this.$refs.recordingVideo.src = url
      },
      startAnimation() {
        this.animationId = requestAnimationFrame(this.updateProgress)
      },
      updateProgress() {
        if (this.progress < 100) {
          this.progress += 100 / (this.recordingDuration * 60) // Tăng tiến độ dựa trên thời gian mong muốn
          this.strokeDashoffset = this.circumference - (this.circumference * this.progress) / 100
          this.animationId = requestAnimationFrame(this.updateProgress)
        } else {
          this.stopAnimation()
        }
      },
      stopAnimation() {
        cancelAnimationFrame(this.animationId)
        this.animationId = null
        this.progress = 0 // Đặt lại tiến độ
      },
    },
  }
</script>
<style scoped>
  .webrtc-camera {
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 1rem;
  }

  .camera-control {
    display: flex;
    justify-content: center;
    margin-bottom: 1rem;
  }

  .camera-button,
  .control-button {
    width: 80px;
    height: 80px;
    border-radius: 50%;
    background-color: #ccc;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    margin: 10px;
    position: relative; /* Để có thể đặt timer-circle bên trong */
  }

  .camera-button.recording {
    background-color: #f44336; /* Màu nền khi đang quay video */
  }

  .control-button {
    background-color: #4caf50; /* Màu nền cho các nút điều khiển */
  }

  .camera-button .inner-circle,
  .control-button .inner-circle {
    width: 60px;
    height: 60px;
    border-radius: 50%;
    background-color: #fff;
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .camera-button .inner-circle .square {
    width: 30px;
    height: 30px;
    background-color: #f44336;
  }

  .timer-circle {
    position: absolute;
    top: 10px;
    left: 10px;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border-top-color: transparent;
    border-right-color: transparent;
    transform: rotate(-90deg);
    transition:
      stroke-dashoffset 1s linear,
      border-color 1s linear; /* Thêm hiệu ứng chuyển màu */
    stroke-dasharray: 157px; /* Độ dài của đường viền vòng tròn */
  }

  .camera-button.recording .timer-circle {
    border-color: rgba(244, 67, 54, 1); /* Màu đậm khi đang quay */
  }

  .progress-circle {
    margin-top: 10px;
    width: 80px;
    height: 80px;
    cursor: pointer;
  }

  .progress-circle__background {
    stroke: #e6e6e6;
    stroke-width: 10;
    fill: transparent;
  }

  .progress-circle__value {
    stroke-width: 10;
    fill: transparent;
    transition: stroke-dashoffset 0.5s ease;
  }
</style>
